/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.page-header[_ngcontent-%COMP%]{text-align:center;font-size:1.5rem;margin-bottom:30px}.back-and-reset-row[_ngcontent-%COMP%]{text-align:right;margin-top:20px}"];
export { styles as styles };
